import moment from "moment"
import i18n from "@/plugins/i18n"

const currentLocale = () => i18n.locale || "en"

// English keeps the existing DD-MMM-YYYY; other locales get a numeric date so no
// English month abbreviation ("Jun", "DEC") leaks into a translated UI.
export const localeDateFormat = () =>
  currentLocale() === "en" ? "DD-MMM-YYYY" : "DD/MM/YYYY"

export const formatLocaleDate = (value, { utc = false, withTime = false, uppercase = false } = {}) => {
  if (!value) return value
  const parsed = utc ? moment.utc(value) : moment(value)
  if (!parsed.isValid()) return value
  const format = withTime ? `${localeDateFormat()} | HH:mm:ss` : localeDateFormat()
  const formatted = parsed.format(format)
  return uppercase ? formatted.toUpperCase() : formatted
}

// Uses the app language (not the browser's) for the decimal separator: 0.35 → "0,35" in pt.
// Latin digits are forced so locales such as ar/mr/ne keep the digits they show today.
export const formatLocaleNumber = (value, maximumFractionDigits = 2) => {
  if (value === null || value === undefined || value === "") return value
  const number = Number(value)
  if (!Number.isFinite(number)) return value
  return new Intl.NumberFormat(`${currentLocale()}-u-nu-latn`, { maximumFractionDigits }).format(number)
}
